import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Subject, combineLatest } from 'rxjs';

import { filter, map, startWith, takeUntil } from 'rxjs/operators';

import { UsersService } from 'src/app/pages/users/users.service';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css'],
})
export class BreadCrumbComponent implements OnInit, OnDestroy {
  breadcrumbs: Breadcrumb[] = [];
  private destroy$ = new Subject<void>();

  private businessTransform: Record<string, string> = {
    lubricants: 'Lubricantes',
    nocore: 'No Core',
    fuels: 'Combustibles',
    foreign: 'Externos',
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {
    const navigation$ = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(null)
    );

    combineLatest([
      navigation$,
      this.usersService.business.pipe(startWith('')),
      this.usersService.inBusinessSelector.pipe(startWith(true)),
    ])
      .pipe(
        map(([_, business, inSelector]) =>
          this.buildBreadcrumbs(business, inSelector)
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((bc) => {
        this.breadcrumbs = bc;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private buildBreadcrumbs(
    business: string,
    inSelector: boolean
  ): Breadcrumb[] {
    const breadcrumbs: Breadcrumb[] = [{ label: 'Inicio', url: '/home' }];
    let route = this.route.root;
    let currentUrl = '';

    while (route.firstChild) {
      route = route.firstChild;

      if (route.outlet !== 'primary') continue;

      const segment = this.getRouteSegment(route);
      if (!segment) continue;

      currentUrl += `/${segment}`;

      const breadcrumb = this.createBreadcrumb(
        route,
        currentUrl,
        business,
        inSelector
      );
      if (breadcrumb) {
        breadcrumbs.push(breadcrumb);
        currentUrl = breadcrumb.url;
      }
    }

    return breadcrumbs;
  }

  private getRouteSegment(route: ActivatedRoute): string {
    return route.snapshot?.url?.map((s) => s.path).join('/') || '';
  }

  private createBreadcrumb(
    route: ActivatedRoute,
    url: string,
    business: string,
    inSelector: boolean
  ): Breadcrumb | null {
    let label = route.snapshot.data['breadcrumb'];
    if (!label) return null;

    if (label === 'business' && !inSelector) {
      return this.handleBusinessBreadcrumb(route, business);
    }

    return {
      label,
      url: url.replace('/home', ''),
    };
  }

  private handleBusinessBreadcrumb(
    route: ActivatedRoute,
    business: string
  ): Breadcrumb {
    const routeBusiness = route.snapshot.params['business'] ?? business;
    return {
      label: this.businessTransform[routeBusiness] ?? routeBusiness,
      url: `/home/${business}`,
    };
  }
}
export interface Breadcrumb {
  label: string;
  url: string;
}
